import React from 'react';

interface IRibbonVerticalDividerProps {
  width?: number;
  color?: string;
}

export default (props: IRibbonVerticalDividerProps) => {
  return <div style={{
      backgroundColor: props.color ?? '#888', 
      width: `${props.width ?? 1}px`,
      display: 'inline-flex',
      height: '-webkit-fill-available',
      margin: '10px 0px'
    }} />;
};
